<app-anonymous-page-layout>
  <app-card class="register-card">
    <app-page-title
      [title]="'PAGE.ONBOARDING_BRAND.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    <form [formGroup]="form" (ngSubmit)="register()" class="form-layout">
      <app-form-element
        class="item -half"
        [label]="'LABEL.FIRSTNAME' | translate"
        inputId="firstname"
        [errors]="formHelper.getErrors('firstname')"
      >
        <mat-form-field>
          <input matInput id="firstname" required formControlName="firstname" />
        </mat-form-field>
      </app-form-element>

      <app-form-element
        class="item -half"
        [label]="'LABEL.LASTNAME' | translate"
        inputId="lastname"
        [errors]="formHelper.getErrors('lastname')"
      >
        <mat-form-field>
          <input matInput id="lastname" required formControlName="lastname" />
        </mat-form-field>
      </app-form-element>

      <app-form-element class="item" [label]="'LABEL.EMAIL' | translate" inputId="email" [errors]="formHelper.getErrors('email')">
        <mat-form-field>
          <input matInput id="email" required formControlName="email" />
        </mat-form-field>
      </app-form-element>

      <app-form-element
        class="item"
        [label]="'LABEL.PHONE' | translate"
        inputId="phoneNumber"
        [errors]="formHelper.getErrors('phoneNumber')"
      >
        <mat-form-field>
          <input matInput id="phoneNumber" type="tel" required [formControl]="form.controls.phoneNumber" />
        </mat-form-field>
      </app-form-element>

      <app-form-element class="item" [label]="'LABEL.COMPANY' | translate" inputId="company" [errors]="formHelper.getErrors('company')">
        <mat-form-field>
          <input matInput id="company" required formControlName="company" />
        </mat-form-field>
      </app-form-element>

      <app-form-element
        class="item"
        [label]="'PAGE.ONBOARDING_BRAND.COMPANY_TYPE.LABEL' | translate"
        inputId="company-type"
        [description]="'PAGE.ONBOARDING_BRAND.COMPANY_TYPE.DESCRIPTION' | translate"
        [errors]="formHelper.getErrors('companyType')"
      >
        <mat-form-field>
          <mat-select id="company-type" formControlName="companyType">
            <mat-option *ngFor="let companyType of companyTypes" [value]="companyType">
              {{ 'ENUM.COMPANY_TYPE.' + companyType | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-form-element>

      <app-form-element
        class="item"
        [label]="'LABEL.INDUSTRY_SECTOR' | translate"
        inputId="industry-sector"
        [errors]="formHelper.getErrors('industrySector')"
      >
        <mat-form-field>
          <mat-select id="industry-sector" formControlName="industrySector">
            <mat-option *ngFor="let sector of industrySectors" [value]="sector">
              {{ 'ENUM.INDUSTRY_SECTOR.' + sector | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-form-element>

      <app-form-element class="item" inputId="termsAccepted" label="" [errors]="formHelper.getErrors('termsAccepted')">
        <mat-checkbox formControlName="termsAccepted">
          <div [innerHTML]="'LABEL.ACCEPT_TERMS' | translate"></div>
        </mat-checkbox>
      </app-form-element>
      <div class="actions">
        <app-button [label]="'LABEL.CREATE_ACCOUNT' | translate" [disabled]="isSaving" [stretched]="true"></app-button>
      </div>
    </form>
  </app-card>
</app-anonymous-page-layout>
